import { ticketingWorkflow } from '@/content/services/workflows/ticketing/ticketing-workflow'
import type { PopupInitialData } from '../popupInitialData'
import getSiteIdInTicketingWorkflow from './getSiteIdInTicketingWorkflow'

export const getSinglePopupId = (path: string, initialData: PopupInitialData[]): number | undefined => {
    if (!initialData) return
    const dataSanitized = initialData.map(popup => {
        // Replace * with . for regex-compatible 'catch all'
        return { ...popup, pageRules: popup?.pageRules?.map(rule => rule.replace(/\*/g, '.')) }
    })

    const pageEnabledData = dataSanitized?.find(popup =>
        popup?.pageRules?.some(rule => {
            // Check if the 'rule' does not contain a dot ('.').
            if (rule.indexOf('.') === -1) {
                // Return true if 'path' matches the 'rule'.
                return path.match(new RegExp(`^${rule}$`))
            } else if (rule.indexOf('.') !== -1) {
                // The regular expression breakdown:
                // ^                   Asserts the start of the string.
                // ${rule.replace('.', '.+')}  Replaces the dot ('.') in the 'rule' with '.+' to match any character.
                // (?:                 Starts a non-capturing group.
                //   \\?               Matches the question mark in the URL, indicating the start of the query string.
                //   .+               Matches one or more of any character in the query string.
                //   (?:&.+)          Matches an ampersand followed by one or more of any character in subsequent query string parameters.
                // )*                  Closes the non-capturing group and allows it to repeat zero or more times.
                // ?                   Makes the entire non-capturing group optional.
                // $                   Asserts the end of the string.
                return `${path}${window.location.search}`.match(
                    new RegExp(`^${rule.replace('.', '.+')}(?:\\?.+(?:&.+)*)?$`)
                )
            } else {
                return path.match(new RegExp(`^${rule}$`)) // Handle other rules as needed
            }
        })
    )

    const siteEnabledData =
        ticketingWorkflow.inProgress() && !pageEnabledData?.enabledSiteIdsForTransactionFlows?.length
            ? pageEnabledData?.enabledSiteIdsForTransactionFlows?.includes(getSiteIdInTicketingWorkflow())
                ? pageEnabledData
                : undefined
            : pageEnabledData

    return siteEnabledData?.id
}
